import {
  Alert,
  AlertIcon,
  Box,
  Divider,
  Flex,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import FileUploadSVG from '../../assets/fileUploadSVG.svg';
import ImageSVG from '../../assets/ImageSVG.svg';
import PDFSVG from '../../assets/PDFSVG.svg';

import { FileUploader } from 'react-drag-drop-files';

const DraggableUploadCard = ({ isStudyChat, handleChange, multiple }) => {
  const [error, setError] = useState('');

  const validateFile = file => {
    if (
      (file.type.includes('image') && file.size > 2 * 1024 * 1024) ||
      (file.type.includes('pdf') && file.size > 6 * 1024 * 1024)
    ) {
      return false;
    }
    return true;
  };

  const handleFileUpload = file => {
    let validFile = file;
    if (!multiple) {
      // single file selection
      if (!validateFile(file)) {
        setError('File size limit exceed');
        return;
      }
      validFile = [file];
    } else {
      // validate and upload files which are of correct size
      validFile = Array.from(file).filter(f => validateFile(f));
      if (validFile.length !== file.length) {
        setError('Some files exceed size limit');
      }
    }
    handleChange(validFile);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      textAlign="center"
      flexDir="column"
      color="#1B2559"
    >
      <Flex justifyContent="center" maxHeight="48px">
        {error && (
          <Alert status="error">
            <AlertIcon />
            {error}
          </Alert>
        )}
      </Flex>
      <Box display="flex" justifyContent="center" textAlign="center">
        <FileUploader
          multiple={multiple}
          handleChange={handleFileUpload}
          onDrop={handleFileUpload}
          name="file"
          types={['JPEG', 'PNG', 'WEBP', 'HEIC', 'HEIF', 'PDF']}
        >
          <Flex
            direction="column"
            p="44px"
            border="1px dashed #4318FF"
            borderRadius="10px"
            cursor="pointer"
          >
            <Flex alignItems="flex-end" justifyContent="center">
              <Image
                src={ImageSVG}
                w={{ base: '3rem', md: '6rem' }}
                h={{ base: '3rem', md: '6rem' }}
              />
              <Image
                src={FileUploadSVG}
                w={{ base: '6rem', md: '12rem' }}
                h={{ base: '6rem', md: '12rem' }}
              />
              <Image
                src={PDFSVG}
                w={{ base: '3rem', md: '6rem' }}
                h={{ base: '3rem', md: '6rem' }}
              />
            </Flex>
            <Text fontSize="0.8rem">Drag & Drop</Text>
            <Text fontWeight="800" fontSize={{ base: '1rem', md: '1.1rem' }}>
              {isStudyChat ? (
                <>
                  Upload <span style={{ color: '#1B56FF' }}>PDF</span> or{' '}
                  <span style={{ color: '#1B56FF' }}>TXT</span> files here
                </>
              ) : (
                <>
                  Upload <span style={{ color: '#1B56FF' }}>PDF</span> or{' '}
                  <span style={{ color: '#1B56FF' }}>Image</span> here to solve
                </>
              )}
            </Text>
          </Flex>
        </FileUploader>
      </Box>
    </Box>
  );
};

export default DraggableUploadCard;
